import { useEffect, useRef, useState } from "react";
import { Sparkles, Image as ImageIcon, Trash2, Upload, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import { Switch } from "@/components/ui/switch";

// Staff/installatore: attiva la "Vista Pro" per un cliente azienda e ne carica il logo.
export function VistaProToggle({ u, logoU, params }) {
  const [d, setD] = useState(null);
  const [busy, setBusy] = useState(false);
  const inp = useRef(null);
  const load = () => api.get(u, { params }).then((r) => setD(r.data)).catch(() => setD(null));
  useEffect(() => { load(); }, [u]); // eslint-disable-line react-hooks/exhaustive-deps
  const set = async (v) => {
    try { await api.put(u, { pro: v }, { params }); toast.success(v ? "Versione Pro attivata" : "Versione Pro disattivata"); load(); }
    catch (e) { toast.error(e.response?.data?.detail || "Errore"); }
  };
  const upload = async (e) => {
    const file = e.target.files?.[0]; if (inp.current) inp.current.value = ""; if (!file) return;
    setBusy(true);
    try { const fd = new FormData(); fd.append("file", file); await api.post(logoU, fd, { params }); toast.success("Logo caricato"); load(); }
    catch (err) { toast.error(err.response?.data?.detail || "Errore"); } finally { setBusy(false); }
  };
  const rimuovi = async () => {
    setBusy(true);
    try { await api.delete(logoU, { params }); toast.success("Logo rimosso"); load(); }
    catch { toast.error("Errore"); } finally { setBusy(false); }
  };
  if (!d) return null;
  return (
    <div className="space-y-2 rounded-xl bg-[#FBF3EE] p-3 ring-1 ring-[#C17F59]/20" data-testid="vista-pro">
      <label className="flex items-center justify-between gap-3">
        <span className="flex items-start gap-2"><Sparkles className="mt-0.5 h-4 w-4 shrink-0 text-[#C17F59]" />
          <span><b className="block text-slate-800">Versione Pro</b>
            <span className="text-xs text-slate-500">Sblocca domande illimitate a Vesta, funzione manutentore, informazioni extra, più accessi e il logo del cliente</span></span></span>
        <Switch checked={d.pro} onCheckedChange={set} data-testid="vista-pro-switch" />
      </label>
      {!d.azienda && <p className="text-xs text-amber-600" data-testid="vista-pro-nota">Nota: questo impianto non risulta un'utenza aziendale (≤ 20 kWp).</p>}
      {!d.pro && d.trial?.attivo && (
        <p className="rounded-lg bg-white/70 px-2 py-1.5 text-xs text-[#9d6a4a] ring-1 ring-[#C17F59]/20" data-testid="vista-pro-trial">
          <b>Prova gratuita attiva</b> ({d.trial.tipo}, {d.trial.mesi} mesi dall'attivazione): scade tra {d.trial.giorni_rimanenti} {d.trial.giorni_rimanenti === 1 ? "giorno" : "giorni"} (il {new Date(d.trial.fine).toLocaleDateString("it-IT")}). Alla scadenza torna automaticamente alla versione base.
        </p>
      )}
      {d.pro && (
        <div className="flex items-center justify-between gap-2 border-t border-[#C17F59]/15 pt-2" data-testid="vista-pro-logo">
          <span className="flex items-center gap-2 text-xs text-slate-600"><ImageIcon className="h-4 w-4 text-[#C17F59]" />{d.has_logo ? "Logo cliente caricato" : "Nessun logo cliente"}</span>
          <span className="flex gap-1.5">
            <input ref={inp} type="file" accept="image/png,image/jpeg,image/webp,image/svg+xml" className="hidden" onChange={upload} data-testid="vista-pro-logo-input" />
            <button type="button" onClick={() => inp.current?.click()} disabled={busy} data-testid="vista-pro-logo-upload"
              className="inline-flex items-center gap-1 rounded-lg bg-white px-2.5 py-1 text-xs font-bold text-[#C17F59] ring-1 ring-[#C17F59]/30 disabled:opacity-50">
              {busy ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Upload className="h-3.5 w-3.5" />}Carica</button>
            {d.has_logo && <button type="button" onClick={rimuovi} disabled={busy} data-testid="vista-pro-logo-remove" className="rounded-lg p-1.5 text-slate-400 hover:bg-white hover:text-rose-500"><Trash2 className="h-3.5 w-3.5" /></button>}
          </span>
        </div>
      )}
    </div>
  );
}
